// Evaluador de expresiones `visibleIf` para render condicional. Soporta una
// forma mínima y suficiente:
//   <path> <op> <literal>
// donde:
//   <path>   = row.<key> | data.<key> (resuelve contra el contexto)
//   <op>     = ==, !=, ===, !==, >, <, >=, <=
//   <literal> = 'CLP' | "CLP" | 123 | true | false | null
//
// Sin paréntesis ni AND/OR. Suficiente para "data.moneda !== 'CLP'" o
// "data.discount > 0". Si necesitás más, migrá a una lib tipo jmespath.
//
// Deliberadamente NO usa `new Function()` ni `eval`.

const OPS = ['===', '!==', '==', '!=', '>=', '<=', '>', '<'];

function parseLiteral(raw) {
  const t = raw.trim();
  if (t === 'true') return true;
  if (t === 'false') return false;
  if (t === 'null') return null;
  if ((t.startsWith("'") && t.endsWith("'")) || (t.startsWith('"') && t.endsWith('"'))) {
    return t.slice(1, -1);
  }
  const n = Number(t);
  if (!Number.isNaN(n)) return n;
  throw new Error(`Literal inválido: ${raw}`);
}

function resolvePath(path, row, data) {
  const parts = path.split('.');
  if (parts.length < 2) return undefined;
  const [scope, ...rest] = parts;
  let ctx;
  if (scope === 'row') ctx = row;
  else if (scope === 'data') ctx = data;
  else throw new Error(`Scope desconocido: ${scope}`);
  for (const key of rest) {
    if (ctx == null) return undefined;
    ctx = ctx[key];
  }
  return ctx;
}

function compare(op, a, b) {
  switch (op) {
    case '===':
      return a === b;
    case '!==':
      return a !== b;
    case '==':
      return a == b; // eslint-disable-line eqeqeq
    case '!=':
      return a != b; // eslint-disable-line eqeqeq
    case '>':
      return a > b;
    case '<':
      return a < b;
    case '>=':
      return a >= b;
    case '<=':
      return a <= b;
    default:
      throw new Error(`Op desconocido: ${op}`);
  }
}

export function evaluateVisibleIf(expr, { row = {}, data = {} } = {}) {
  if (expr == null || expr === '') return true;
  const s = String(expr).trim();
  for (const op of OPS) {
    const idx = s.indexOf(op);
    if (idx > 0) {
      const lhs = s.slice(0, idx).trim();
      const rhs = s.slice(idx + op.length).trim();
      const lval = resolvePath(lhs, row, data);
      const rval = parseLiteral(rhs);
      return compare(op, lval, rval);
    }
  }
  throw new Error(`Expresión visibleIf sin operador soportado: ${expr}`);
}
